import {
    failedFetchingProducts,
    setAvailableProducts,
    startFetchingProducts,
} from '../reducers/productsAvailableReducer';
import {AppDispatch} from '..';
import httpService from '../../services/HttpService';
import {ApiPlant} from '../../models/Model';
import transformApiPlantsToIPlantCategoryArray
    from '../../helper/transforms/transformApiPlantsToIPlantCategoryArray';

const plantBaseUrl = process.env.REACT_APP_PLANT_IMAGE_BASE_URL;

export const getProductsAction = () => {
  return (dispatch: AppDispatch) => {
    dispatch(startFetchingProducts());
    return httpService
        .get<{plant_catalog_items: ApiPlant[]}>('plant-catalog/device-types/indoor_greenhouse')
        .then((res) => {
          const { plant_catalog_items } = res.body;
          dispatch(setAvailableProducts(transformApiPlantsToIPlantCategoryArray(plant_catalog_items, plantBaseUrl as string)));
        })
        .catch(() => failedFetchingProducts());
  };
};